import Rest from '@/services/Rest'

export default class DocumentTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/documentTypes'

}
